import { Datagrid, List, TextField, SelectInput } from 'react-admin'

export const ListLetters = () => (
  <List
    exporter={false}
    hasCreate={false}
    hasEdit={true}
    perPage={100}
    filters={[
      <SelectInput
        source="trimester"
        choices={[
          { id: '1', name: 'T1' },
          { id: '2', name: 'T2' },
          { id: '3', name: 'T3' },
          { id: '4', name: 'T4' },
        ]}
      />,
    ]}
    sort={{ field: 'id', order: 'DESC' }}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="copromatic_id" label="Id copromatic" />
      <TextField source="ag_convocation_total_cost" />
      <TextField source="ag_pv_total_cost" />
      <TextField source="general_total_cost" />
      <TextField source="total_cost" />
    </Datagrid>
  </List>
)
